<template>
  <b-row no-gutters>
    <b-col cols="auto">
      <b-form-group
        label="Ülke Kodu"
        label-for="phone2_region_code"
      >
        <div class="d-flex">
          <vue-country-code
            :preferred-countries="['tr', 'de', 'az']"
            class="form-control"
            :default-country="dataItem.phone2_region_iso2"
            @onSelect="onSelect"
          />
          <b-form-input
            id="phone2_region_code"
            v-model="dataItem.phone2_region_code"
            type="number"
            class="bg-light phone_region_code"
            readonly
          />
        </div>
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group
        label="Telefon 2"
        label-for="phone2"
      >
        <cleave
          id="phone"
          v-model="dataItem.phone2"
          class="form-control phone_number"
          :raw="true"
          :options="options.phone"
          placeholder="Telefon 2"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormGroup, BFormInput, BRow, BCol,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.tr'
import VueCountryCode from 'vue-country-code'

export default {
  name: 'Phone2',
  components: {
    BFormGroup,
    BFormInput,
    Cleave,
    BRow,
    BCol,
    VueCountryCode,
  },
  data() {
    return {
      options: {
        phone: {
          phone: true,
          phoneRegionCode: 'TR',
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['customers/dataItem']
    },
  },
  methods: {
    onSelect({ iso2, dialCode }) {
      this.dataItem.phone2_region_iso2 = iso2
      this.dataItem.phone2_region_code = dialCode
    },
  },
}
</script>
